
// // import { useState } from 'react';
// // import { useParams, Link, useNavigate } from 'react-router-dom';
// // import { useFetchOne } from '../../hooks/useFetch';
// // import { getMediaURL, getEmbedUrl } from '../../utils/helpers';
// // import Loading from '../../components/common/Loading';
// // import ErrorMessage from '../../components/common/ErrorMessage';
// // import ReactMarkdown from 'react-markdown';
// // import SocialShares from '../../components/common/Socials/SocialShares';
// // import { API_ENDPOINTS, URL_ENDPOINTS, POPULATE_PARAMS } from '../../config/constants';
// // import { toTurkishDate } from '../../utils/dateConvertToTr';

// // const Symposium = () => {
// //     const { slug } = useParams();
// //     const navigate = useNavigate();
// //     const { data: symposium, loading, error } = useFetchOne(API_ENDPOINTS.SYMPOSIUMS, slug, POPULATE_PARAMS.NESTED_SYMPOSIUMS);

// //     if (loading) return <Loading />;
// //     if (error) return <ErrorMessage message={error} />;
// //     if (!symposium) {
// //         return (
// //             <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
// //                 <ErrorMessage message="İçerik bulunamadı" />
// //                 <div className="text-center mt-8">
// //                     <button
// //                         onClick={() => navigate(-1)}
// //                         className="px-8 py-4 bg-blue-900 text-white rounded font-semibold hover:bg-blue-800 transition-colors"
// //                     >
// //                         ← Geri Dön
// //                     </button>
// //                 </div>
// //             </div>
// //         );
// //     }

// //     const { symposium: dir, publishedAt } = symposium;

// //     const imageUrl = dir.cover ? getMediaURL(dir.cover) : '/placeholder_hor.jpg';

// //     // Extract YouTube links from markdown content
// //     const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/g;
// //     const youtubeVideos = [...(dir.description?.matchAll(youtubeRegex) || [])].map(m => m[0]);

// //     const cleanedContent = dir.description
// //         ?.replace(/!\[.*?\]\(.*?\)/g, '')
// //         ?.replace(youtubeRegex, '')
// //         || '';

// //     return (
// //         <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-2 lg:py-8">
// //             {/* Breadcrumb */}
// //             <nav className="mb-4 text-sm text-gray-600">
// //                 <Link to="/" className="text-blue-900 hover:underline">Ana Sayfa</Link>
// //                 <span className="mx-2 text-gray-400">/</span>
// //                 {/* <Link to={`/${URL_ENDPOINTS.DIRECTORATES}`} className="text-blue-900 hover:underline">Direktörlükler</Link> */}
// //                 <Link to="/" className="text-blue-900 hover:underline">Sempozyumlar</Link>

// //                 <span className="mx-2 text-gray-400">/</span>
// //                 <span className="text-gray-800">{dir.title}</span>
// //             </nav>

// //             {/* Back Button */}
// //             <button
// //                 onClick={() => navigate(-1)}
// //                 className="inline-block mb-4 px-4 py-2 text-blue-900 font-medium rounded hover:bg-gray-100 transition-colors"
// //             >
// //                 ← Geri Dön
// //             </button>

// //             <h1 className="text-3xl sm:text-4xl font-bold text-blue-900 mb-6 leading-tight">
// //                 {dir.title}
// //             </h1>

// //             {/* Meta Information */}
// //             {publishedAt && (
// //                 <div className="mb-8 pb-4 border-b-2 border-gray-100">
// //                     <span className="text-sm sm:text-base text-gray-600">
// //                         Yayınlama tarihi: {toTurkishDate(publishedAt)}
// //                     </span>
// //                 </div>
// //             )}

// //             {/* Article */}
// //             <article className="bg-white rounded-lg shadow-md overflow-hidden">
// //                 {/* Cover Image */}
// //                 <div className="w-full max-h-96 sm:max-h-[500px] overflow-hidden">
// //                     <img
// //                         src={imageUrl}
// //                         alt={dir.title}
// //                         className="w-full h-auto object-cover"
// //                     />
// //                 </div>

// //                 {/* Content */}
// //                 <div className="p-6 sm:p-8 lg:p-10">
// //                     {/* Description */}
// //                     <div className="prose prose-lg max-w-none text-gray-800 mb-8 leading-relaxed">
// //                         <ReactMarkdown
// //                             components={{
// //                                 img: () => null,
// //                                 p: ({ node, ...props }) => <p {...props} className="mb-4" />,
// //                                 h1: ({ node, ...props }) => <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />,
// //                                 h2: ({ node, ...props }) => <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />,
// //                                 h3: ({ node, ...props }) => <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />,
// //                                 ul: ({ node, ...props }) => <ul {...props} className="list-disc list-inside mb-4 space-y-2" />,
// //                                 ol: ({ node, ...props }) => <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />,
// //                                 a: ({ node, ...props }) => <a {...props} className="text-blue-900 hover:underline" />,
// //                             }}
// //                         >
// //                             {cleanedContent}
// //                         </ReactMarkdown>
// //                     </div>

// //                     {/* YouTube Videos */}
// //                     {youtubeVideos.length > 0 && (
// //                         <div className="my-8 space-y-6">
// //                             {youtubeVideos.map((videoUrl, index) => (
// //                                 <div key={index} className="relative w-full pb-[56.25%] rounded-lg overflow-hidden shadow-lg">
// //                                     <iframe
// //                                         src={getEmbedUrl(videoUrl)}
// //                                         title={`YouTube video ${index + 1}`}
// //                                         frameBorder="0"
// //                                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
// //                                         allowFullScreen
// //                                         className="absolute top-0 left-0 w-full h-full"
// //                                     />
// //                                 </div>
// //                             ))}
// //                         </div>
// //                     )}

// //                     {/* Full Content */}
// //                     {dir.content && (
// //                         <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-8">
// //                             {dir.content}
// //                         </p>
// //                     )}

// //                     {/* Back Button */}
// //                     <div className="mt-12 pt-8 border-t border-gray-200">
// //                         <button
// //                             onClick={() => navigate(-1)}
// //                             className="px-6 py-3 bg-blue-900 text-white rounded font-medium hover:bg-blue-800 transition-colors"
// //                         >
// //                             ← Geri Dön
// //                         </button>
// //                     </div>
// //                 </div>
// //             </article>

// //             <SocialShares />
// //         </div>
// //     );
// // };

// // export default Symposium;




// import { useState } from "react";
// import { useParams, Link, useNavigate } from "react-router-dom";
// import { useFetchOne } from "../../hooks/useFetch";
// import Loading from "../../components/common/Loading";
// import ErrorMessage from "../../components/common/ErrorMessage";
// import { API_ENDPOINTS, POPULATE_PARAMS } from "../../config/constants";
// import { getMediaURL } from "../../utils/helpers";
// import { toTurkishDate } from "../../utils/dateConvertToTr";
// import { FaCalendarAlt } from "react-icons/fa";
// import { LuMapPin } from "react-icons/lu";


// const Symposium = () => {
//     const { slug } = useParams();
//     const navigate = useNavigate();
//     const { data: symposium, loading, error } = useFetchOne(
//         API_ENDPOINTS.SYMPOSIUMS,
//         slug,
//         POPULATE_PARAMS.NESTED_SYMPOSIUMS
//     );

//     const [activeIndex, setActiveIndex] = useState(null);

//     if (loading) return <Loading />;
//     if (error) return <ErrorMessage message={error} />;
//     if (!symposium) return <ErrorMessage message="İçerik bulunamadı" />;

//     const { symposium: dir, publishedAt } = symposium;

//     const imageUrl = dir.cover ? getMediaURL(dir.cover) : "/placeholder_hor.jpg";

//     return (
//         <div className="w-full">

//             {/* ================= SLIDER (EMPTY FOR NOW) ================= */}
//             <div className="max-w-6xl mx-auto px-4 mt-6">
//                 <div className="bg-gray-300 rounded-2xl h-[300px] flex items-center justify-center text-3xl font-semibold text-gray-700">
//                     SEMPOZYUM SLIDER'I
//                 </div>
//             </div>

//             {/* ================= MAIN INTRO SECTION ================= */}
//             <div className="max-w-6xl mx-auto px-4 mt-16 grid md:grid-cols-3 gap-12">

//                 {/* LEFT CONTENT */}
//                 <div className="md:col-span-2">
//                     <h1 className="text-4xl font-bold text-blue-900 mb-6">
//                         {dir.title}
//                     </h1>

//                     {dir.subtitle && (
//                         <p className="text-lg text-gray-700 leading-relaxed mb-6">
//                             {dir.subtitle}
//                         </p>
//                     )}

//                     {dir.description && (
//                         <p className="text-gray-600 leading-relaxed mb-8">
//                             {dir.description}
//                         </p>
//                     )}

//                     <button className="bg-blue-900 text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-800 transition">
//                         Kayıt Olmak için Tıklayınız
//                     </button>
//                 </div>

//                 {/* RIGHT INFO CARD */}
//                 <div className="space-y-6">

//                     <div className="flex items-center gap-4">
//                         <FaCalendarAlt className="text-blue-900" />
//                         <div>
//                             <p className="font-semibold text-blue-900">Tarih</p>
//                             <p className="text-gray-600">
//                                 {dir.date ? toTurkishDate(dir.date) : "Tarih Belirtilmemiş"}
//                             </p>
//                         </div>
//                     </div>

//                     <div className="flex items-center gap-4">
//                         <LuMapPin className="text-blue-900" />
//                         <div>
//                             <p className="font-semibold text-blue-900">Yer</p>
//                             <p className="text-gray-600">
//                                 {dir.location || "Konum Belirtilmemiş"}
//                             </p>
//                         </div>
//                     </div>

//                 </div>
//             </div>

//             {/* ================= SEMPOZYUM HAKKINDA ================= */}
//             <div className="max-w-6xl mx-auto px-4 mt-20 mb-20">
//                 <h2 className="text-3xl font-bold text-blue-900 mb-10">
//                     Sempozyum Hakkında
//                 </h2>

//                 <div className="grid md:grid-cols-2 gap-12">

//                     {/* ACCORDION */}
//                     <div className="space-y-6">
//                         {dir.symposium?.map((item, index) => (
//                             <div key={item.id} className="border rounded-md">
//                                 <button
//                                     onClick={() =>
//                                         setActiveIndex(activeIndex === index ? null : index)
//                                     }
//                                     className="w-full text-left px-4 py-3 font-medium bg-gray-100 hover:bg-gray-200 transition"
//                                 >
//                                     + {item.title}
//                                 </button>

//                                 {activeIndex === index && (
//                                     <div className="px-4 py-4 text-gray-700 bg-white border-t">
//                                         {item.description}
//                                     </div>
//                                 )}
//                             </div>
//                         ))}
//                     </div>

//                     {/* POSTER IMAGE */}
//                     <div>
//                         <img
//                             src={imageUrl}
//                             alt={dir.title}
//                             // className="rounded-xl shadow-md w-full object-cover"
//                             className="w-[300px] rounded-xl shadow-md object-cover"

//                         />
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Symposium;



import { useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchOne } from "../../hooks/useFetch";
import ReactMarkdown from 'react-markdown';
import { getMediaURL, getEmbedUrl } from "../../utils/helpers";
import Loading from "../../components/common/Loading";
import ErrorMessage from "../../components/common/ErrorMessage";
import Slider from "../../components/common/Slider/Slider";
import { API_ENDPOINTS, POPULATE_PARAMS } from "../../config/constants";
import { toTurkishDate } from "../../utils/dateConvertToTr";
import { FaCalendarAlt } from "react-icons/fa";
import { LuMapPin } from "react-icons/lu";
import { FiChevronDown } from "react-icons/fi";

const Symposium = () => {
    const { slug } = useParams();
    const { data: symposium, loading, error } = useFetchOne(
        API_ENDPOINTS.SYMPOSIUMS,
        slug,
        POPULATE_PARAMS.NESTED_SYMPOSIUMS
    );

    const [activeIndexes, setActiveIndexes] = useState([]);

    if (loading) return <Loading />;
    if (error) return <ErrorMessage message={error} />;
    if (!symposium) return <ErrorMessage message="İçerik bulunamadı" />;

    const { symposium: dir } = symposium;

    const imageUrl = dir.cover
        ? getMediaURL(dir.cover)
        : "/placeholder_hor.jpg";

    const toggleAccordion = (index) => {
        setActiveIndexes((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };
    // Extract YouTube links from markdown content
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/g;
    const youtubeVideos = [...(dir.description?.matchAll(youtubeRegex) || [])].map(m => m[0]);

    const cleanedContent = dir.description
        ?.replace(/!\[.*?\]\(.*?\)/g, '')
        ?.replace(youtubeRegex, '')
        || '';

    return (
        <div className="w-full pb-16">
            <Slider API_ENDPOINTS_SLIDER={API_ENDPOINTS.SYMPOSIUMS} PARAMS_SLIDER={POPULATE_PARAMS.SYMPOSIUM_SLIDER} slug={slug} />

            {/* ================= MINIMAL DIVIDER ================= */}
            <div className="max-w-6xl mx-auto px-4 mt-2">
                <div className="h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent" />
            </div>

            {/* ================= INTRO SECTION ================= */}
            {/* Kept as a 3-col grid: content takes 2, details take 1 */}
            <div className="max-w-6xl mx-auto px-4 mt-8 grid md:grid-cols-3 gap-12">
                <div className="md:col-span-2">
                    <h1 className="text-4xl font-bold text-blue-900 mb-6">
                        {dir.title}
                    </h1>
                    {/* 

                    {dir.description && (
                        <p className="text-gray-600 leading-relaxed mb-8">
                            {dir.description}
                        </p>
                    )}
 */}


                    {/* Content */}
                    <div className="p-6 sm:p-8 lg:p-10">
                        {/* Description */}
                        <div className="prose prose-lg max-w-none text-gray-800 mb-8 leading-relaxed">
                            <ReactMarkdown
                                components={{
                                    img: () => null,
                                    p: ({ node, ...props }) => <p {...props} className="mb-4" />,
                                    h1: ({ node, ...props }) => <h1 {...props} className="text-2xl sm:text-3xl font-bold mt-8 mb-4" />,
                                    h2: ({ node, ...props }) => <h2 {...props} className="text-xl sm:text-2xl font-bold mt-6 mb-3" />,
                                    h3: ({ node, ...props }) => <h3 {...props} className="text-lg sm:text-xl font-bold mt-4 mb-2" />,
                                    ul: ({ node, ...props }) => <ul {...props} className="list-disc list-inside mb-4 space-y-2" />,
                                    ol: ({ node, ...props }) => <ol {...props} className="list-decimal list-inside mb-4 space-y-2" />,
                                    a: ({ node, ...props }) => <a {...props} className="text-blue-900 hover:underline" />,
                                }}
                            >
                                {cleanedContent}
                            </ReactMarkdown>
                        </div>

                        {/* YouTube Videos */}
                        {youtubeVideos.length > 0 && (
                            <div className="my-8 space-y-6">
                                {youtubeVideos.map((videoUrl, index) => (
                                    <div key={index} className="relative w-full pb-[56.25%] rounded-lg overflow-hidden shadow-lg">
                                        <iframe
                                            src={getEmbedUrl(videoUrl)}
                                            title={`YouTube video ${index + 1}`}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            className="absolute top-0 left-0 w-full h-full"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}



                    </div>

                    {/* {dir.regLink && (
                        <a
                            href={dir.regLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block bg-blue-900 !text-white visited:text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-800 transition shadow-md hover:shadow-lg no-underline"
                        >
                            Kayıt Olmak için Tıklayınız
                        </a>
                    )} */}

                    {dir.regLink && (
                        <div className="flex justify-center md:justify-start">
                            <a
                                href={dir.regLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block bg-blue-900 !text-white visited:text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-800 transition shadow-md hover:shadow-lg no-underline"
                            >
                                Kayıt Olmak için Tıklayınız
                            </a>
                        </div>
                    )}
                </div>

                <div className="space-y-8 bg-gray-50 p-6 rounded-2xl border border-gray-100 h-fit">
                    <div className="flex items-center gap-4">
                        <div className="p-3 bg-blue-100 rounded-lg">
                            <FaCalendarAlt className="text-blue-900 text-xl" />
                        </div>
                        <div>
                            <p className="font-semibold text-blue-900">Tarih</p>
                            <p className="text-gray-600">
                                {dir.date
                                    ? dir.date
                                    : "Tarih Belirtilmemiş"}
                            </p>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <div className="p-3 bg-blue-100 rounded-lg">
                            <LuMapPin className="text-blue-900 text-xl" />
                        </div>
                        <div>
                            <p className="font-semibold text-blue-900">Yer</p>
                            <p className="text-gray-600">
                                {dir.location || "Konum Belirtilmemiş"}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= MINIMAL DIVIDER ================= */}
            <div className="max-w-6xl mx-auto px-4 mt-16">
                <div className="h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent" />
            </div>

            {/* ================= SEMPOZYUM HAKKINDA ================= */}
            <div className="max-w-6xl mx-auto px-4 mt-16">


                {dir.subtitle && (
                    <p className="text-3xl font-bold text-blue-900 mb-8">
                        {dir.subtitle}
                    </p>
                )}

                {/* Changed to a 3-col grid to match the header alignment */}
                <div className="grid md:grid-cols-3 gap-12 items-start">

                    {/* ================= ACCORDION ================= */}
                    <div className="md:col-span-2 space-y-4">
                        {dir.symposium?.map((item, index) => {
                            const isOpen = activeIndexes.includes(index);

                            return (
                                <div
                                    key={item.id}
                                    className="rounded-xl overflow-hidden transition-all duration-300 border border-gray-200 shadow-sm bg-white"
                                >
                                    <button
                                        onClick={() => toggleAccordion(index)}
                                        className={`w-full flex justify-between items-center px-6 py-5 transition-colors focus:outline-none focus:bg-gray-50
                                            ${isOpen ? "bg-blue-50/50 border-b border-blue-100" : "hover:bg-gray-50"}
                                        `}
                                    >
                                        <span className={`text-lg font-semibold text-left transition-colors ${isOpen ? "text-blue-900" : "text-gray-800"}`}>
                                            {item.title}
                                        </span>

                                        <FiChevronDown
                                            className={`text-2xl text-blue-900 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                                                }`}
                                        />
                                    </button>

                                    <div
                                        className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen
                                            ? "max-h-[1000px] opacity-100" // Safely large max-height
                                            : "max-h-0 opacity-0"
                                            }`}
                                    >
                                        {/* Content container remains white */}
                                        <div className="px-6 py-6 text-gray-700 leading-relaxed bg-white">
                                            {item.description}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* ================= STICKY IMAGE ================= */}
                    <div className="md:col-span-1">
                        <div className="sticky top-24">
                            <img
                                src={imageUrl}
                                alt={dir.title}
                                /* Removed max-w-sm to allow it to fill its grid column naturally */
                                className="w-full aspect-[4/5] object-cover rounded-2xl shadow-xl transition-transform duration-500 hover:scale-[1.02] border border-gray-100"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Symposium;